<template>
	<el-card class="box-card">
		<template #header>
			<div class="card-header">
				<span>限时购设置</span>
				<el-button class="button" @click='edit("")' type="success">新增限时购</el-button>
			</div>
		</template>
		<div class="col">
	 		<el-table v-loading="loading" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" empty-text="暂无数据" :data="panic_list" style="width: 100%;" border highlight-current-row>
				<el-table-column prop="id" label="编号" width="50">
				</el-table-column>
	 			<el-table-column label="商品信息">
	 				<template #default="scope">
						<el-table :data="scope.row.discount_goods" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}"  height="250">
						    <el-table-column prop="product_name" label="商品名"></el-table-column>
						    <el-table-column prop="product_model" label="商品版号"></el-table-column>
							<el-table-column prop="panic_goods_price" label="限时购价格"></el-table-column>
						</el-table>
	 				</template>
	 			</el-table-column>
	 			<el-table-column label="开始时间">
	 				<template #default="scope">
	 					{{timestampToTime(scope.row.start_time)}}
	 				</template>
	 			</el-table-column>
	 			<el-table-column label="结束时间">
	 				<template #default="scope">
	 					{{timestampToTime(scope.row.end_time)}}
	 				</template>
	 			</el-table-column>
	 			<el-table-column label="操作" align="center" width="200">
	 				<template #default="scope">
	 					<el-button type="primary" size="mini" @click="edit(scope.row)">编辑</el-button>
	 					<el-button type="danger" size="mini" @click="destroy(scope.row)">删除</el-button>
	 				</template>
	 			</el-table-column>
	 		</el-table>
	 	</div>
	</el-card>
	<el-dialog :title="title" v-model="dialogFormVisible">
		<div class="col">
			<el-form label-position="left" label-width="100px" :model="item" ref="form" :rules="rules">
				<el-row :gutter="20">
					<el-col :span="12">
						<el-form-item label="开始日期" prop="start_time">
							<el-input style="width: 220px;" v-model="item.start_time" type="date" placeholder="选择开始时间" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="结束日期" prop="end_time">
							<el-input style="width: 220px;" v-model="item.end_time" type="date" placeholder="选择结束时间" autocomplete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>

				<el-form-item v-show="discount_goods_show" label="商品选取" prop="discount_goods">
					<!-- <el-button v-slot="control">商品选取</el-button> -->
					<cs-product-select ref="newForm" dataType='productCloth' :check-list="item.discount_goods" @confirm='handleGoodsConfirm'>
					</cs-product-select>
				</el-form-item>

				<el-table :data="item.discount_goods">
					<el-table-column label="编号" prop="id"></el-table-column>
					<el-table-column label="商品名称" prop="product_name"></el-table-column>
					<el-table-column label="商品版号" prop="product_model"></el-table-column>
					<el-table-column label="限时购价格" prop="panic_goods_price">
						<template #default='scope'>
							<el-input style='width: 150px;' size="small" placeholder="请输入限时购价格" v-model="scope.row.panic_goods_price"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="操作">
						<template v-slot="scope">
							<el-button @click="remove(scope.$index)" type="warning" size="mini">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-form>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button @click="dialogFormVisible = false">取 消</el-button>
			<el-button type="primary" @click="submit()">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import csProductSelect from '../common/cs-product-select.vue'

	export default {
		name: 'PanicPromotion',
		components: {
			csProductSelect
		},
		data() {
			return {
				loading: true,
				title:'新增限时购',
				dialogFormVisible: false,
				panic_list:[],
				discount_goods_show:true,
				item: {
					start_time: '',
					end_time: '',
					discount_goods: [],
				},
				rules: {
					start_time:[{
						required: true,
						message: '请填写开始时间',
						trigger: 'blur'
					}],
					end_time:[{
						required: true,
						message: '请填写结束时间',
						trigger: 'blur'
					}],
				},
			}
		},
		methods: {
			edit(row) {
				let temp = this.cloneObj(row);
				console.log(temp)
				if (row) {
					this.title = '编辑限时购';
					this.discount_goods_show = false
					this.item = temp;
					this.item.start_time = this.timestampToTime(temp.start_time);
					this.item.end_time = this.timestampToTime(temp.end_time);

				} else {
					this.title = '新增限时购';
					this.discount_goods_show = true
					this.resetObj(this.item)
				}
				this.dialogFormVisible = true;

				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
				})
			},
			destroy(row) {
				console.log(row.id)
				let id = row.id
				// return false;
				this.msgBoxAjax('警告', '确定删除吗?', '/admin/promotion/panicPromotionDel', {
					id: id
				}).then((re) => {
					if (re.code > 1) return this.$message.error(re.msg)
					this.getPanicPromotion();
				})
			},
			handleGoodsConfirm(val) {
				let discount = []
				val.forEach(value => {
					discount.push({
						id: value.id,
						product_model: value.product_model,
						product_name: value.product_name,
					})
				})
				this.item.discount_goods = discount;
			},
			remove(index) {
				this.item.discount_goods.splice(index, 1)
			},
			submit() {
				this.$refs['form'].validate((valid) => {
					if (valid) {
						let panic_goods_price_rules = /^\+?[1-9][0-9]*$/; // 正整数
						if(this.item.discount_goods.length==0){
							return this.$message.error('未选择商品')
						}
						for(let i in this.item.discount_goods){
							// panic_goods_price
							if(!this.item.discount_goods[i].panic_goods_price){
								return this.$message.error('版号:'+this.item.discount_goods[i].product_model+'未填写价格')
							}
							if (!panic_goods_price_rules.test(this.item.discount_goods[i].panic_goods_price)) {
								return this.$message.error('版号:'+this.item.discount_goods[i].product_model+'格式不对,输入正整数')
							}
						}
						console.log(this.item);
						// return false;
						this.httpPost({
							url: '/admin/promotion/panicPromotionUpdate',
							data: this.item
						}).then((re) => {
							// console.log(re);
							this.dialogFormVisible = false;
							this.resetObj(this.item)
							this.getPanicPromotion();
							// this.getCategoryDiscount();
						})
					} else {
						console.log('error submit!')
						return false;
					}
				})
			
			},
			getPanicPromotion(){
				this.httpPost({
					url: '/admin/promotion/panicPromotionList',
					data: {
						routePath: this.$route.path
					}
				}).then((re) => {
					let data = re.data
					console.log(data)
					let temp = this.cloneObj(data);
					this.panic_list = temp;
					this.loading = false;
							
				}).catch((err) => {})
			}
		},
		created() {
			this.getPanicPromotion();
		}
	}
</script>

<style>
</style>
